export default __webpack_public_path__ + "static/media/AddPanelIcon.8dd7ae8a.svg";